import React from 'react';
import { motion } from 'framer-motion';
export function BookingBanner() {
  return <section className="relative py-24 md:py-32 parallax-bg flex items-center justify-center" style={{
    backgroundImage: 'url(https://images.unsplash.com/photo-1540555700478-4be289fbecef?q=80&w=2070&auto=format&fit=crop)'
  }} data-id="element-23">
      <div className="absolute inset-0 bg-brand-charcoal/70 z-0" data-id="element-24"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-26">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-6" data-id="element-27">
            Your Skin Deserves the Very Best
          </h2>

          <p className="text-lg md:text-xl text-white/90 mb-10 font-light" data-id="element-28">
            Book your customized treatment today and experience the K'Bella
            difference.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-29">
            <a href="#contact" className="w-full sm:w-auto bg-brand-teal text-white px-10 py-4 rounded-sm font-semibold text-lg hover:bg-teal-500 transition-colors min-h-[48px] flex items-center justify-center shadow-lg" data-id="element-30">
              Book Now
            </a>
            <div className="flex flex-col items-center sm:items-start" data-id="element-31">
              <span className="text-white/70 text-sm uppercase tracking-wider mb-1" data-id="element-32">
                Call to schedule
              </span>
              <a href="tel:5202338576" className="text-2xl md:text-3xl font-heading text-white hover:text-brand-teal transition-colors" data-id="element-33">
                (520) 233-8576
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}